module.exports = __webpack_public_path__ + "static/media/logo-prefeitura.a0cef862.svg";